import React, { Fragment, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as ApplicantAction from "../../pages/applicant/_redux/applicantActions";
import moment from "moment";
import API from "../../helpers/devApi";
import { swalError, swalSuccess } from "../../helpers/swal";
import { Progress, Space } from "antd";

export function ProfileCard({ id }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [image, setImage] = useState(false);
  const { employeeProfile } = useSelector(
    ({ applicant }) => ({
      employeeProfile: applicant.personal_info,
    }),
    shallowEqual
  );

  const handleChangeProfile = async (file) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("user_image", file);
    await API.patch(`/hrms_applicant/update-profile-photo/${id}`, formData)
      .then((res) => {
        if (res.data.success) {
          swalSuccess("Profile Updated");
          dispatch(
            ApplicantAction.createProfileScore(
              {
                name: ["Profile Image"],
                applicant_id: id,
              },
              () => {
                dispatch(ApplicantAction.getApplicantPersonalInfo(id));
              }
            )
          );
        } else {
          if (res.data.message) {
            swalError(res.data.message);
            setLoading(false);
          } else {
            swalError("something went wrong");
            setLoading(false);
          }
        }
      })
      .catch((error) => {
        swalError("something went wrong");
        setLoading(false);
      });

    setLoading(false);
  };

  useEffect(() => {
    dispatch(ApplicantAction.getApplicantPersonalInfo(id));
  }, [dispatch, id]);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card profile_card_main">
          <div className="left_box">
            <div className="image_box">
              <img
                src={
                  image
                    ? URL.createObjectURL(image)
                    : employeeProfile?.profile_image
                    ? `${process.env.REACT_APP_IMAGE_BASE_URL}${employeeProfile?.profile_image}${process.env.REACT_APP_IMAGE_TOKEN_KEY}`
                    : "https://www.svgrepo.com/show/508699/landscape-placeholder.svg"
                }
                alt="No img"
              />
              {/* <button className="change_photo_icon_btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M13.5 5H10.5813L10.3141 4.25313L9.95625 3.25H6.04219L5.68437 4.25313L5.41719 5H2.5C2.43125 5 2.375 5.05625 2.375 5.125V12.25C2.375 12.3188 2.43125 12.375 2.5 12.375H13.5C13.5688 12.375 13.625 12.3188 13.625 12.25V5.125C13.625 5.05625 13.5688 5 13.5 5ZM8 11C6.61875 11 5.5 9.88125 5.5 8.5C5.5 7.11875 6.61875 6 8 6C9.38125 6 10.5 7.11875 10.5 8.5C10.5 9.88125 9.38125 11 8 11Z" fill="#E6F7FF"/>
                                        <path d="M8 6.00001C6.61875 6.00001 5.5 7.11876 5.5 8.50001C5.5 9.88126 6.61875 11 8 11C9.38125 11 10.5 9.88126 10.5 8.50001C10.5 7.11876 9.38125 6.00001 8 6.00001ZM8 10C7.17188 10 6.5 9.32813 6.5 8.50001C6.5 7.67188 7.17188 7.00001 8 7.00001C8.82812 7.00001 9.5 7.67188 9.5 8.50001C9.5 9.32813 8.82812 10 8 10Z" fill="#1890FF"/>
                                        <path d="M13.5 3.875H11.375L10.8687 2.45625C10.8338 2.35917 10.7697 2.27525 10.6852 2.21596C10.6008 2.15668 10.5001 2.12491 10.3969 2.125H5.60313C5.39219 2.125 5.20312 2.25781 5.13281 2.45625L4.625 3.875H2.5C1.80937 3.875 1.25 4.43438 1.25 5.125V12.25C1.25 12.9406 1.80937 13.5 2.5 13.5H13.5C14.1906 13.5 14.75 12.9406 14.75 12.25V5.125C14.75 4.43438 14.1906 3.875 13.5 3.875ZM13.625 12.25C13.625 12.3188 13.5688 12.375 13.5 12.375H2.5C2.43125 12.375 2.375 12.3188 2.375 12.25V5.125C2.375 5.05625 2.43125 5 2.5 5H5.41719L6.04219 3.25H9.95625L10.5813 5H13.5C13.5688 5 13.625 5.05625 13.625 5.125V12.25Z" fill="#1890FF"/>
                                    </svg>
                                </button> */}
            </div>
            <div className="info_box">
              {id && (
                <Fragment>
                  <h2 className="mb-1 text-white">
                    {employeeProfile?.first_name +
                      " " +
                      `${
                        employeeProfile?.middle_name != null
                          ? employeeProfile?.middle_name
                          : ""
                      }` +
                      " " +
                      (employeeProfile?.last_name || "")}
                  </h2>
                  <p className="mb-1 text-white">
                    {employeeProfile?.pre_address_line_1
                      ? employeeProfile?.pre_address_line_1
                      : "N/A"}
                  </p>
                </Fragment>
              )}
              {/* <button className="change_photo_btn"><i className="fas fa-camera mr-2"></i> Change photo</button> */}

              {id && (
                <div className="avatar-upload">
                  <div className="avatar-edit">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      disabled={!id}
                      onChange={(e) => {
                        setImage(e.target.files[0]);
                        handleChangeProfile(e.target.files[0]);
                      }}
                    />
                    <label htmlFor="imageUpload" className="profile_upload_btn">
                      <i className="fas fa-camera mr-2"></i>
                      Change photo
                    </label>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="right_box">
            <Space wrap>
              <Progress
                type="circle"
                percent={parseInt(employeeProfile?.profile_percentage)}
                strokeColor="#ed7784"
                format={(percent) => (
                  <>
                    <span
                      className="d-block text-light"
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      {`${percent}%`}
                    </span>
                    <span
                      style={{
                        color:
                          employeeProfile?.profile_percentage === 100
                            ? "#FFF"
                            : "#ff9ea9",
                        fontSize: "12px",
                        lineHeight: "5px",
                      }}
                    >
                      {employeeProfile?.profile_percentage === 100
                        ? "Profile Completed"
                        : "Profile Completion"}
                    </span>
                  </>
                )}
              />
            </Space>
            {/* <div className="progress blue">
              <span className="progress-left">
                <span className="progress-bar"></span>
              </span>
              <span className="progress-right">
                <span className="progress-bar"></span>
              </span>
              <div className="progress-value">
                <h3 className="text-white">90%</h3>
                <p className="text-white">
                  Profile <br /> Complete
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
